var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { Router } from 'aurelia-router';
var ManageUserDashboards = /** @class */ (function () {
    function ManageUserDashboards(router) {
        this.router = router;
    }
    ManageUserDashboards.prototype.activate = function (param) {
        if (param.dashboardId) {
            var isGlobal = param.isGlobal !== 'false';
            var isReadonly = param.isReadonly !== 'false';
            this.dashboardId = param.dashboardId;
            this.name = param.name;
            this.isGlobal = isGlobal;
            this.isReadonly = isReadonly;
        }
    };
    ManageUserDashboards.prototype.goBack = function () {
        this.router.navigateBack();
    };
    ManageUserDashboards = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [Router])
    ], ManageUserDashboards);
    return ManageUserDashboards;
}());
export { ManageUserDashboards };
